import Banner from 'components/Banner';
import CareerForm from 'components/FormSection/Forms/CareerForm';
import JobLabels from 'components/JobLabels';
import TextWithIcon from 'components/TextWithIcon';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVacancy, selectVacanciesContent } from 'store/slices/CareerSlice';

const DetailedJob = () => {
    const { slug } = useParams();
    const dispatch = useDispatch();
    const content = useSelector(selectVacanciesContent);

    React.useEffect(() => {
        dispatch(
            // @ts-ignore
            fetchVacancy({ slug }),
        );
    }, [dispatch, slug]);

    const { title, data, experience, locations, work_type, title_background, created_at, fs_button } = content;

    return (
        <>
            <Banner image={title_background} buttonText={fs_button}>
                <h2>{title}</h2>
                <JobLabels experience={experience} locations={locations} work_type={work_type} />
                <TextWithIcon iconName="calendar" text={created_at} />
            </Banner>

            <article className="article-content" dangerouslySetInnerHTML={{ __html: data }} />

            <CareerForm />
        </>
    );
};

export default DetailedJob;
